import { useTranslation } from 'react-i18next';
import { mergeClasses } from '@fluentui/react-components';
import { useRunOfShowSummaryStyles } from './RunOfShowSummary.styles';

export interface RunOfShowSummaryProps {
  totalEvents: number;
  totalAttendees: number;
  largeEventCount: number;
}

export const RunOfShowSummary = ({ totalEvents, totalAttendees, largeEventCount }: RunOfShowSummaryProps) => {
  const styles = useRunOfShowSummaryStyles();
  const { t } = useTranslation('reports');

  return (
    <div className={styles.root} data-testid="run-of-show-summary" role="group" aria-label={t('runOfShow.summaryLabel')}>
      <div className={styles.metric}>
        <span className={styles.metricValue}>{totalEvents}</span>
        <span className={styles.metricLabel}>{t('runOfShow.events')}</span>
      </div>
      <div className={styles.metric}>
        <span className={styles.metricValue}>{totalAttendees}</span>
        <span className={styles.metricLabel}>{t('runOfShow.attendees')}</span>
      </div>
      <div className={styles.metric}>
        <span className={mergeClasses(styles.metricValue, styles.metricLarge)}>{largeEventCount}</span>
        <span className={mergeClasses(styles.metricLabel, styles.metricLarge)}>{t('runOfShow.largeEvents')}</span>
      </div>
    </div>
  );
};

RunOfShowSummary.displayName = 'RunOfShowSummary';
